import axios from "axios";
import {server} from "@/variables";

export function getRegions() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/list/regions`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}